import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateVendorPaymentCommand,
  GetAllBookingsByVendorAndStatusCommand,
  GetAllVendorPaymentByVendorIdCommand,
  GetBookingsByVendorPaymentIdByDateRangeCommand,
  GetVendorPaymentsByVendorIdByDateRangeCommand,
} from './vendor-payment.commands';
import {
  CreatedVendorPaymentEvent,
  GotAllBookingsByVendorAndStatusEvent,
  GotAllVendorPaymentByVendorIdEvent,
  GotBookingsByVendorPaymentIdByDateRangeEvent,
} from './vendor-payment.events';

@Injectable()
export class VendorPaymentEffects {
  prefix = 'vendor-payment';
  getAllVendorPaymentByVendorIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  createVendorPaymentCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllBookingsByVendorAndStatusCommand: Observable<Action<string>> & CreateEffectMetadata;
  getBookingsByVendorPaymentIdByDateRangeCommand: Observable<Action<string>> & CreateEffectMetadata;
  getVendorPaymentsByVendorIdByDateRangeCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.getAllVendorPaymentByVendorIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllVendorPaymentByVendorIdCommand,
      GotAllVendorPaymentByVendorIdEvent,
      this.prefix,
    );

    this.createVendorPaymentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateVendorPaymentCommand,
      CreatedVendorPaymentEvent,
      this.prefix,
    );

    this.getAllBookingsByVendorAndStatusCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllBookingsByVendorAndStatusCommand,
      GotAllBookingsByVendorAndStatusEvent,
      this.prefix,
    );

    this.getBookingsByVendorPaymentIdByDateRangeCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetBookingsByVendorPaymentIdByDateRangeCommand,
      GotBookingsByVendorPaymentIdByDateRangeEvent,
      this.prefix,
    );

    this.getVendorPaymentsByVendorIdByDateRangeCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetVendorPaymentsByVendorIdByDateRangeCommand,
      GotAllVendorPaymentByVendorIdEvent,
      this.prefix,
    );
  }
}
